import { useEffect } from 'react';
import { useQuery } from './useQuery';
import { useStore } from '@/contexts/StoreContext';
import { useAB } from '@tajawal/web-common/lib';
import { AB_TESTING_FLAGS } from '@/constants/analytics.constants';

export default function useFetchAds(): void {
  const store = useStore();
  const { isRoundTrip } = useQuery();
  const { active: isAdButlerEnabled } = useAB(AB_TESTING_FLAGS.AD_BUTLER);
  const pageStore = !isRoundTrip ? store.appStore.completeSearchPage : store.appStore.stepByStepSearchPage.outbound;

  useEffect(() => {
    if (isAdButlerEnabled) {
      pageStore.fetchAdPlacements();
    }
  }, [pageStore, isAdButlerEnabled]);
}
